export const PREV_RESULT_SIZE = 30;
export const NEXT_RESULT_SIZE = 15;

export const MAX_USER_MENTION_COUNT = 10;
export const MAX_USER_SUGGESTION_COUNT = 15;
export const USER_MENTION_TEMP_CHAR = '@';
